export default class Quotation {
  constructor(data) {
    if(!data) {
      data = {};
    }
    this._id = data._id;
    this.title = data.title;
    this.description = data.description;
    this.tjm = data.tjm;
    this.company = data.company;
    this.duration = data.duration;
    this.discount = data.discount;
    this.tasks = data.tasks;
    this.amount = data.amount;
  }
}
